import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { startWith } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FormListeners } from '../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { setContribLegge59PerditeBilancioListeners } from './contrib-legge59-perdite-bilancio.listeners';
import { setContribLegge59RisultatoEsercizioListeners } from './contrib-legge59-risultato-esercizio.listeners';
import { setContribLegge59CalcoliContributoListeners } from './contrib-legge59-calcoli-contributo.listeners';
import { setContribLegge59FondoBeneficiarioListeners } from './contrib-legge-59-fondo-beneficiario.listeners';
import { getContribLegge59Control, getContribLegge59Group } from '../validators/helpers/contrib-legge-59-92-form.helpers';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { toNum } from '@shared/helpers/math.helper';
import { ERROR_MESSAGE_CONTRIBUTO_LEGGE_59 } from '@shared/constants/shared.constants';

export function manageErrorMessageLegge59(form: FormGroup, toastrService: ToastrService): void {
    const importoComplessivo: string = getContribLegge59Control(form, 'my_ImportoComplessivo').value;
    const importoVersato: string = getContribLegge59Control(form, 'my_ImportoVersato')?.value;
    const showToast =
        !isNilOrEmpty(importoComplessivo) &&
        !isNilOrEmpty(importoVersato) &&
        Math.floor(toNum(importoVersato)) < Math.floor(toNum(importoComplessivo)) &&
        toNum(importoComplessivo) >= 10.33 &&
        !isNilOrEmpty(sessionStorage.getItem('verbale_idAssegnazione'));
    if (showToast) {
        toastrService.error(ERROR_MESSAGE_CONTRIBUTO_LEGGE_59, undefined, { positionClass: 'toast-top-left' });
    }
}

export class ContribLegge5992FormListeners extends FormListeners {
    constructor(
        form: FormGroup,
        private readonly store: Store<Revisione53State>,
        private readonly toastrService: ToastrService
    ) {
        super(form);
    }

    setListeners(): void {
        setContribLegge59PerditeBilancioListeners(this.form, this.store);
        setContribLegge59RisultatoEsercizioListeners(this.form, this.store);
        setContribLegge59CalcoliContributoListeners(this.form, this.store);
        setContribLegge59FondoBeneficiarioListeners(this.form, this.store);
        this._setImportoComplessivoListener();
    }

    private _setImportoComplessivoListener(): void {
        const group = getContribLegge59Group(this.form);
        group.valueChanges.pipe(startWith(group.value)).subscribe(() => {
            manageErrorMessageLegge59(this.form, this.toastrService);
        });
    }
}
